export default __webpack_public_path__ + "static/media/blessing-baby.c40a4a55.jpg";